export default "__VITE_ASSET__BuejIo1p__"